import axios from 'axios'
import ApiErrors from '../utilities/ApiErrors';

export default {

    async get() {

        try {
            const { data } = await axios({ url: '/alertas/', method: 'GET' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

}